(function(){

	// Library depencencies
	var Application = include('springroll.Application'),
		Texture = include('PIXI.Texture'),
		Container = include('PIXI.Texture'),
		Sprite = include('PIXI.Sprite'),
		GeomUtils = include('heist.GeomUtils'),
		PixiUtils = include('PIXI.utils'),
		Debug = include('springroll.Debug', false);
	
	//set some Pixi constants for our use
	PixiUtils.useFilenamesForTextures = true;

	/**
	*  The main class of Cookie Heist
	*  @class CookieHeist
	*  @extends springroll.Application
	*/
	var CookieHeist = function(options)
	{
		Application.call(this, options);
		
		//cursor, either the Sesame star or a magnifying glass
		this._currentCursor = null;
		//cursor container, for both the current cursor and the sparkles
		this.cursor = null;
		//PixiParticles emitter for cursor sparkles
		this._sparkles = null;
		//Sesame default cursor for desktop
		this._starCursor = null;
		//keep track of the cursor to only use the most recent finger on touch
		this._cursorID = null;
		//keeping track of position to determine taps for stage 2 reasons
		this._startPos = {x:0, y:0};
		//keeping track of taps vs touch drags for stage 2 reasons
		this._isTap = false;
		//current config containing clue layouts and suspects
		this.currentCrimeConfig = null;
		//don't repeat letters unless we run out
		this.playedLetters = [];
		
		//disable right click
		document.body.addEventListener("contextmenu",
			function(e){ e.preventDefault(); return false; });
		document.getElementById(options.canvasId).addEventListener("contextmenu",
			function(e){ e.preventDefault(); return false; });

		this.onResize = this.onResize.bind(this);
		this.on("resize", this.onResize, -1);

		this.update = this.update.bind(this);
		this.onTransitionOut = this.onTransitionOut.bind(this);
		
		this.once("configLoaded", onConfigLoaded.bind(this));
		this.once("init", onInit.bind(this));
		
		//track launch
		this.trackEvent(["launch", "Detective Elmo The Cookie Case"]);
		
		//keep track of the total number of plays this session
		this.totalPlays = 0;
		this.totalTime = 0;
		
		//set up a listener for when the window unloads so we can do tracking and cleanup.
		this.onWindowUnload = this.onWindowUnload.bind(this);
		window.addEventListener("unload", this.onWindowUnload);
		
		if(DEBUG)
		{
			window.destroy = this.onWindowUnload;
		}
	};

	// Extend the base game class
	var p = CookieHeist.prototype = Object.create(Application.prototype);

	p.onWindowUnload = function()
	{
		window.removeEventListener("unload", this.onWindowUnload);
		
		this.destroy();//destroy the game
	};

	/**
	 *  Callback when the config is loaded
	 *  @method onConfigLoaded
	 *  @private
	 *  @param {springroll.LoaderResult} result The Loader result from the load task
	 */
	var onConfigLoaded = function(config, assets)
	{
		//on mobile, resize to the top window to get the correct size due to browser UI.
		if(this.hasTouch && !this.container.connected)
			this._resizeElement = window.top;
		
		//load assets we will need immediately/globally
		assets.append(config.assets.loadTransition, config.assets.cursor);
		
		// if(window.GAME_IS_SESAME_CONTEXT && window.doNotDisplayClose !== true &&
		// 		!this.container.connected)
		// {
		// 	assets.append(config.assets.quitButton);
		// }
		
		//add the cutscene display
		var display = this.addDisplay(
			"cutscene",
			springroll.easeljs.EaselJSDisplay,
			{
				clearView:false
			});
		display.enabled = false;
		display.visible = false;
	};

	var onInit = function()
	{
		var canvas = this.display.canvas;
		//Cancel defaults from touch events to avoid scrolling and mouse events
		//in addition to the touch events
		if(this.hasTouch)
		{
			var touchCanceller = function(ev)
			{
				ev.preventDefault();
			};
			canvas.addEventListener("touchstart", touchCanceller);
			canvas.addEventListener("touchmove", touchCanceller);
			canvas.addEventListener("touchend", touchCanceller);
		}
		
		var stage = this.display.stage;
		//display the close button if needed
		// if(window.GAME_IS_SESAME_CONTEXT && window.doNotDisplayClose !== true &&
		// 		!this.container.connected)
		// {
		// 	this.quitButton = new Sprite(Texture.fromImage("QuitButton"));
		// 	this.quitButton.interactive = true;
		// 	this.onQuitTap = this.onQuitTap.bind(this);
		// 	this.quitButton.on("tap", this.onQuitTap);
		// 	this.quitButton.on("click", this.onQuitTap);
		// 	stage.addChild(this.quitButton);
		// }
		
		//build the load screen transition
		this.transition = new PIXI.spine.Spine(this.getCache("loadTransition").spineData);
		
		var scaling = this.config.scaling;
		var assets = this.config.assets;
		
		this.states =
		{
			title: new heist.TitleState({
				scaling: scaling.title,
				preload: assets.title
			}),
			cutscene: new heist.CutsceneState({
				scaling: scaling.cutscene,
				preload: assets.cutscene,
				delayLoad: 4
			}),
			stealth: new heist.StealthState({
				scaling: scaling.stealth,
				preload: assets.stealth
			}),
			clue: new heist.ClueState({
				scaling: scaling.clues,
				preload: assets.clues
			}),
			suspect: new heist.SuspectState({
				scaling: scaling.suspect,
				preload: assets.suspect
			})
		};
		
		this.scaling.addItem(this.transition,
			{
				x:1024/2,
				y:660/2,
				titleSafe:true,
				align:"top-left"
			});
		this.scaling.enabled = true;
		
		//build the cursor
		this.cursor = new PIXI.Container();

		this._sparkles = new cloudkid.Emitter(
			this.cursor,
			[Texture.fromFrame("SmallStar")],
			this.config.game.cursorEmitter);
		this._sparkles.particleConstructor = cloudkid.PathParticle;
		this._sparkles.emit = false;

		stage.addChild(this.cursor);
		//add the quit button to the top, if it exists
		if(this.quitButton)
			stage.addChild(this.quitButton);
		//set up the listeners/callbacks for the global interactions for our custom cursor
		var interactionManager = this.display.renderer.plugins.interaction;
		if(!this.hasTouch)
		{
			this.stageOut = this.stageOut.bind(this);
			this.stageIn = this.stageIn.bind(this);
			interactionManager.handleCursorChange = this.onCursorChange.bind(this);
			interactionManager.on("stageout", this.stageOut);
			interactionManager.on("stagein", this.stageIn);
		}
		this.stageMove = this.stageMove.bind(this);
		interactionManager.on("stagemove", this.stageMove);
		if(this.hasTouch)
		{
			this.stageDown = this.stageDown.bind(this);
			this.stageUp = this.stageUp.bind(this);
			interactionManager.on("stagedown", this.stageDown);
			interactionManager.on("stageup", this.stageUp);
		}
		else
		{
			//hide the cursor because star cursor
			this.display.canvas.style.cursor = "none";
			this._starCursor = new Sprite(Texture.fromFrame("MainStar"));
			this._starCursor.anchor.x = this._starCursor.anchor.y = 0.5;
			this.setCursor(null);
		}
		this.on("update", this.update);
		this.manager.on("onTransitionOut", this.onTransitionOut);

		//set the initial state
		if(DEBUG)
		{
			if(this.options.cutscene == "scene1")
			{
				this.selectLetter();
				this.cutsceneData =
				{
					nextState: "clue",
					cutscene: "assets/config/scene1.json",
					skipLabel: "CutScreen1"
				};
				this.manager.state = "cutscene";
			}
			else if(this.options.cutscene == "scene2")
			{
				this.selectLetter();
				this.cutsceneData =
				{
					nextState: "suspect",
					cutscene: "assets/config/scene2.json",
					skipLabel: "CutScreen2"
				};
				this.manager.state = "cutscene";
			}
			else if(this.options.cutscene == "outro")
			{
				this.selectLetter();
				this.cutsceneData =
				{
					nextState: "title",
					cutscene: "assets/config/outro.json"
				};
				this.manager.state = "cutscene";
			}
			else if(!this.options.state)
				this.manager.state = "title";
		}
		else
			this.manager.state = "title";
	};
	
	//function for building the main transition and replacing the load transition with it
	p.createMainTransition = function()
	{
		this.scaling.removeItem(this.transition);
		this.display.stage.removeChild(this.transition);
		this.transition.destroy();
		
		var transition = this.transition = new PIXI.spine.Spine(this.getCache("mainTransition").spineData);
		this.scaling.addItem(transition,
			{
				x:1024/2,
				y:660/2,
				titleSafe:true,
				align:"top-left"
			});
		this.scaling.enabled = true;//force a resize

		this.manager._transition = transition;
		this.manager._transitionSounds =
			{
				out:{alias:"SFX_TransitionStart", start:150},
				in:{alias:"SFX_TransitionEnd", start:0}
			};

		this.display.stage.addChild(transition);
		this.display.stage.addChild(this.cursor);
		if(this.quitButton)
			this.display.stage.addChild(this.quitButton);
		transition.visible = false;
	};

	p.onResize = function(w, h)
	{
		//tells the container element what size to be for proper placement
		//due to absolute/relative positioning stuff
		var container = document.getElementById("container");
		container.style.width = w + "px";
		container.style.height = h + "px";
		if(container.scrollIntoViewIfNeeded)
			container.scrollIntoViewIfNeeded(true);
	};

	//selects a letter and a thief within that letter
	p.selectLetter = function()
	{
		var clueConfig = this.config.game.clues, options, i;
		//allow for debugging/developing a specific setup
		if(DEBUG && this.options.letter)
		{
			options = clueConfig.letters[this.options.letter];
			if(options)
			{
				for(i = 0; i < options.length; ++i)
				{
					if(options[i].thief == this.options.thief)
					{
						this.currentCrimeConfig = options[i];
						return;
					}
				}
			}
		}
		//normal random generation
		var letterOptions = clueConfig.letterOptions, prevLetter;
		if(this.playedLetters.length == letterOptions.length)
		{
			//save the last played letter to avoid immediately replaying it
			prevLetter = this.playedLetters[this.playedLetters.length - 1];
			this.playedLetters.length = 0;
		}
		options = [];
		for(i = 0; i < letterOptions.length; ++i)
		{
			if(this.playedLetters.indexOf(letterOptions[i]) == -1 && prevLetter != letterOptions[i])
				options.push(letterOptions[i]);
		}
		var chosenLetter = options.random();
		this.currentCrimeConfig = clueConfig.letters[chosenLetter].random();
		//actually add the letter to the list so we can't play it again
		this.playedLetters.push(chosenLetter);
		
		if(DEBUG && Debug)
		{
			Debug.debug("===============");
			Debug.debug(this.currentCrimeConfig.letter + ": " + this.currentCrimeConfig.thief);
			Debug.debug("===============");
		}
	};
	
	//==== CURSOR STUFF =====

	p.setCursor = function(cursorSprite)
	{
		if(cursorSprite)
		{
			this._currentCursor = cursorSprite;
			this.cursor.addChild(cursorSprite);
			if(this._starCursor)
				this.cursor.removeChild(this._starCursor);
		}
		else
		{
			this.cursor.removeChildren();
			if(this._currentCursor)
				this._currentCursor.destroy();
			this._currentCursor = null;
			if(this._starCursor)
				this.cursor.addChild(this._starCursor);
		}
	};

	p.stageOut = function()
	{
		this.cursor.visible = false;
	};

	p.stageIn = function()
	{
		this.cursor.visible = true;
	};
	
	var DRAG_DIST = 20 * 20;//20 pixels, squared for faster math

	p.stageDown = function(event)
	{
		var data = event.data;
		//Debug.log("stage down - cursor id: " + this._cursorID + ", data id: " + data.id);
		//Because of issues with iOS not telling us that we lost a touch in certain situations,
		//we are always using the latest touch
		//if(this._cursorID === null)
		//{
			//no active primary cursor
			this._cursorID = data.identifier;
			if(this._currentCursor)
			{
				this._startPos.x = data.global.x;
				this._startPos.y = data.global.y;
				this._isTap = true;
			}
		//}
	};

	p.stageMove = function(event)
	{
		var data = event.data;
		//Debug.log("stage move - cursor id: " + this._cursorID + ", data id: " + data.id);
		if(!this.hasTouch || this._cursorID == data.identifier)
		{
			if(this._isTap)
			{
				//if handling the clue finder magnifying glass on mobile, then check to see if
				//we are counting this as a drag instead of a tap
				if(GeomUtils.distanceSq(this._startPos, data.global) >= DRAG_DIST)
					this._isTap = false;
				else
					return;
			}
			var position = this.cursor.position;
			position.x = data.global.x;
			position.y = data.global.y;
		}
	};

	p.stageUp = function(event)
	{
		var data = event.data;
		//Debug.log("stage up - cursor id: " + this._cursorID + ", data id: " + data.id);
		if(this._cursorID == data.identifier)
		{
			//clear active primary cursor
			this._cursorID = null;
			if(this._isTap)
			{
				var position = this.cursor.position,
					_sparkles = this._sparkles;
				position.x = data.global.x - _sparkles.spawnPos.x;
				position.y = data.global.y - _sparkles.spawnPos.y;
			}
		}
	};
	
	p.onCursorChange = function(cursor)
	{
		if(cursor == "pointer")
			this.onPointerCursor();
		else
			this.onDefaultCursor();
	};
	
	p.onPointerCursor = function()
	{
		if(this._currentCursor)
		{
			//this.setCursorSparkle(true);
		}
		else
			this._starCursor.texture = Texture.fromFrame("MainStarRollover");
	};

	p.onDefaultCursor = function()
	{
		if(this._currentCursor)
		{
			//this.setCursorSparkle(false);
		}
		else
			this._starCursor.texture = Texture.fromFrame("MainStar");
	};

	p.onTransitionOut = function()
	{
		//when we transition out, we should make sure the sparkles are not active
		//this._sparkles.emit = false;
		if(this.hasTouch)
			this._cursorID = null;//clear this for mobile
	};

	/*p.setCursorSparkle = function(value)
	{
		if(this._sparkles && (!this.hasTouch || this._currentCursor))
			this._sparkles.emit = value;
	};*/

	p.update = function(elapsed)
	{
		/*if(this._sparkles)
			this._sparkles.update(elapsed * 0.001);*/
		this.totalTime += elapsed;
	};
	
	p.onQuitTap = function()
	{
		window.close();
	};
	
	//====== TRACKING STUFF ========
	p.trackEvent = function(eventInfo)
	{
		this.analyticEvent.apply(this, eventInfo);
		// eventInfo.unshift("Detective Elmo The Cookie Case");

		// if(window.GAME_IS_SESAME_CONTEXT)
		// {
		// 	eventInfo.unshift("_trackEvent");
		// 	window._gaq.push(eventInfo);
		// 	return;
		// }
		// if(window.GAME_IS_PBS_CONTEXT && window.top.GA_obj)
		// {
		// 	window.top.GA_obj.trackEvent.apply(window.top.GA_obj, eventInfo);
		// 	return;
		// }
		// if(DEBUG)
		// 	Debug.log("would be tracking %c" + eventInfo, "color:#FF851B");
	};
	
	p.destroy = function()
	{
		this.trackEvent(["QuitInfo", "GameDuration", Math.round(this.totalTime)]);
		this.trackEvent(["QuitInfo", "GamesVisited_" + this.totalPlays, this.totalPlays]);
		
		this.update = this.onTransitionOut = this.onWindowUnload = null;
		this.quitButton = null;
		
		Application.prototype.destroy.call(this);
	};

	// Assign to namespace
	namespace('heist').CookieHeist = CookieHeist;

}());